import { TableBody, TableCell, TableHead, TableRow } from '@mui/material'

// others
import { CHARTS_OF_ACCOUNTS_HEADERS } from '../../../constants'
import { ChartsOfAccountsListingProps } from '../../../interfaceTypes'

// components
import { StickyTable } from '../../common/StickyTable'
import { CustomPagination } from '../../common/CustomPagination'
import { CustomTableCell } from '../../common/CustomTableCell'
import { TableSkeleton } from '../../skeletons/TableSkeleton'
import { ChartsOfAccountsMenu } from '../../menus/ChartsOfAccounts'
import { enumToLabel, formatCurrency } from '../../../utils'

const ChartsOfAccountsListing = ({ accounts, loading, refetch }: ChartsOfAccountsListingProps) => {
  return (
    <StickyTable pagination={<CustomPagination loading={loading || false} />} height="405px">
      <TableHead>
        <TableRow hover>
          {CHARTS_OF_ACCOUNTS_HEADERS.map((columnName, index) => (
            <TableCell key={index} component="th" align={'left'}>
              {columnName}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      {loading ? (
        <TableSkeleton noOfRows={7} noOfCols={CHARTS_OF_ACCOUNTS_HEADERS.length} />
      ) : (
        <TableBody>
          {accounts?.map(account => {
            const { id, name, sortCode, accountNo, category, currentBalance } = account || {}
            return (
              <TableRow key={id} hover>
                <CustomTableCell value={sortCode || '-'} />
                <CustomTableCell value={name || '-'} to={`/accounts/chartered/${id}`} maxWidth="376px" />
                <CustomTableCell value={enumToLabel(category || '') || '-'} />
                <CustomTableCell value={accountNo || '-'} />
                <CustomTableCell value={formatCurrency(currentBalance || 0)} />

                <TableCell>
                  <ChartsOfAccountsMenu currentChartOfAccount={account} />
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      )}
    </StickyTable>
  )
}

export default ChartsOfAccountsListing
